import React from 'react';
import {
  Box,
  Button,
  Container,
  Heading,
  Text,
  VStack,
  Icon,
} from '@chakra-ui/react';
import { FaExclamationTriangle, FaHome } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

function NotFound() {
  const navigate = useNavigate();

  return (
    <Container maxW="container.xl" py={20}>
      <VStack spacing={8} align="center" textAlign="center">
        {/* Icon */}
        <Box
          p={8}
          borderRadius="full"
          bgGradient="linear(to-r, brand.tealSoft, brand.cream)"
        >
          <Icon 
            as={FaExclamationTriangle} 
            boxSize={24} 
            color="brand.tealDark"
          />
        </Box>

        {/* 404 Text */}
        <Heading
          size="4xl"
          bgGradient="linear(to-r, brand.navy, brand.tealDark)"
          bgClip="text"
          fontWeight="extrabold"
        >
          404
        </Heading>

        {/* Main Message */}
        <VStack spacing={3}>
          <Heading size="xl" color="gray.700">
            Page Not Found
          </Heading>
          <Text color="gray.600" fontSize="lg" maxW="md">
            Oops! The page you're looking for doesn't exist. It might have been moved or deleted.
          </Text>
        </VStack>

        {/* Action Buttons */}
        <VStack spacing={3} pt={4}>
          <Button
            leftIcon={<FaHome />}
            size="lg"
            colorScheme="teal"
            bgGradient="linear(to-r, brand.navy, brand.tealDark)"
            onClick={() => navigate('/')}
            px={8}
            _hover={{
              bgGradient: 'linear(to-r, brand.navy, brand.tealDark)',
            }}
          >
            Go to Homepage
          </Button>
          <Button
            variant="ghost"
            colorScheme="teal"
            onClick={() => navigate(-1)}
          >
            Go Back
          </Button>
        </VStack>
      </VStack>
    </Container>
  );
}

export default NotFound;